module.exports = __webpack_public_path__ + "img/Chambre écureuil.ab6aaa86.jpeg";